import React, { cloneElement } from 'react';
import { IconButton, Stack } from '@mui/material';
import { Refresh as TestIcon } from '@mui/icons-material';
import Menu from '../../../components/elements/menu/Menu';
import Tooltip from '../../elements/mui/Tooltip';
import { ROUTE_CREDENTIALS } from 'js/constants/pathnames';
import RoutePrefixContext from '../../../../new/contexts/RoutePrefixContext';
import { ReactComponent as EditFileIcon } from 'new/components/icons/editFile.svg';
import { ReactComponent as DeleteIcon } from 'new/components/icons/fi-rr-trash.svg';
import { DetailsIconButton } from 'new/elements/Button';
import { ReactComponent as DetailsIcon } from 'new/components/icons/fi-rr-info.svg';
import { RESOURCE_TYPE_CREDENTIALS } from 'js/constants/resourceTypes';
import { editModalsEnabled } from 'new/constants/featureFlags';
import ResourceEditProvider from 'js/components/ResourceEditProvider';
import { ResourceEditContext } from 'js/components/ResourceEditProvider/ResourceEditContext';

const styles = {
  ctaTest: {
    margin: 0,
    padding: 0,
  },
  ctaTestIcon: {
    height: 24,
    color: 'var(--color-primary-500)',
    viewBox: '0 0 24 24',
  },
  ctaTestingProgress: {
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
  },
  menu: {
    icon: {
      color: '#6D7E8F',
      fontSize: 19,
    },
  },
};

class CredentialDetailActions extends React.Component {
  static contextType = RoutePrefixContext;

  constructor(props) {
    super(props);

    this._handleTestClicked = this._handleTestClicked.bind(this);
    this._handleDeleteClicked = this._handleDeleteClicked.bind(this);
    this._handleOpenDetails = this._handleOpenDetails.bind(this);
  }

  render() {
    const {
      data,
      disableEditing,
      disableEditMessage,
      readOnly,
      openDetailsModal,
      showVerify = true,
      ButtonComponent,
      horizontalDots,
      hideMenuDetails,
    } = this.props;

    const isModalEnabled = editModalsEnabled()?.credentials;

    const menuItems = [];

    if (!hideMenuDetails) {
      menuItems.push({
        label: 'Details',
        icon: <DetailsIcon />,
        onClick: this._handleOpenDetails,
      });
    }

    menuItems.push(
      {
        label: 'Edit',
        icon: <EditFileIcon />,
        href: !isModalEnabled ? `${this.context}${ROUTE_CREDENTIALS}/${data.id}/edit` : undefined,
        onClick: isModalEnabled ? this._handleEditClicked : undefined,
        disable: disableEditing,
        disableMessage: disableEditMessage,
      },
      {
        type: 'dialog',
        label: 'Delete',
        icon: <DeleteIcon />,
        dialogMessage: `Please confirm you want to delete the credentials ${data.name} (ID: ${data.id}).`,
        primaryButtonColor: 'error',
        discardLabel: 'Cancel',
        confirmLabel: 'Delete',
        onClick: this._handleDeleteClicked,
      },
    );

    const testCredentialButton = ButtonComponent ? (
      cloneElement(ButtonComponent, { onClick: this._handleTestClicked })
    ) : (
      <Tooltip title="Test Credential" arrow>
        <IconButton
          className="test-credential-button"
          style={styles.ctaTest}
          onClick={this._handleTestClicked}
        >
          <TestIcon fontSize="large" style={styles.ctaTestIcon} />
        </IconButton>
      </Tooltip>
    );

    if (this.props.additionalMenuItems) {
      this.props.additionalMenuItems.forEach((item) => {
        if (item.position === 'bottom') {
          menuItems.push(item);
        } else {
          menuItems.unshift(item);
        }
      });
    }

    const dotMenu = readOnly ? null : <Menu horizontalDots={horizontalDots} items={menuItems} />;

    return (
      <div className="detail-actions">
        {showVerify && testCredentialButton}

        {openDetailsModal ? (
          <Stack marginRight={2} marginLeft={2}>
            <DetailsIconButton onClick={openDetailsModal} />
          </Stack>
        ) : null}

        {dotMenu}
      </div>
    );
  }

  _handleEditClicked = () => {
    this.props.setAction({
      type: 'edit',
      resource: RESOURCE_TYPE_CREDENTIALS,
      id: this.props.data.id,
    });
  };

  _handleOpenDetails(e) {
    if (e && typeof e.stopPropagation === 'function') {
      e.stopPropagation();
    }
    const { data, onOpenDetailsMenu, openDetailDrawerInPortal, openDetailsModal } = this.props;
    if (typeof onOpenDetailsMenu === 'function') {
      onOpenDetailsMenu(data);
      return;
    }
    if (typeof openDetailsModal === 'function') {
      openDetailsModal(data);
      return;
    }
    if (typeof openDetailDrawerInPortal === 'function') {
      openDetailDrawerInPortal(data, {});
    }
  }

  _handleTestClicked(event) {
    event.stopPropagation();

    this.props.probeCredentialAndFetch(this.props.data.id);
  }

  _handleDeleteClicked(event) {
    this.props.deleteCredential(this.props.data.id);
  }
}

CredentialDetailActions.defaultProps = {
  readOnly: false,
  hideMenuDetails: false,
};

const CredentialDetailsActionsWrapper = (props) => {
  return (
    <ResourceEditProvider>
      <ResourceEditContext.Consumer>
        {(consumerProps) => <CredentialDetailActions {...props} {...consumerProps} />}
      </ResourceEditContext.Consumer>
    </ResourceEditProvider>
  );
};

export default CredentialDetailsActionsWrapper;
